var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoopRightLine = function SvgLoopRightLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 6a6 6 0 0 1 4.962 2.625H15.5v1.5H20v-4.5h-1.5V7.5A7.5 7.5 0 0 0 5 12h1.5a6 6 0 0 1 6-6m6 6a6 6 0 0 1-10.962 3.375H9.5v-1.5H5v4.5h1.5V16.5A7.5 7.5 0 0 0 20 12z"
  })));
};
export default SvgLoopRightLine;